export const routes = {

    
    setting: "#/setting",
    
    general: "#/setting/general",
    yourSetup: "#/setting/your-setup",
    mobileOfficers: "#/setting/mobile-officers",
    
    notification: "#/setting/notifications",
    emailTemplates: "#/setting/email-templates",
    zones: "#/setting/zones",

    propertySetting: "#/setting/module",
    docSetting: "#/setting/doc",
    complianceSettings: "#/setting/compliance",
    // appraisal and survey templates + options, one page (the two old links lead to it)
    appraisalsSurveysSettings: "#/setting/appraisals-surveys",
    holidaySettings: "#/setting/holiday",
    uniformSettings: "#/setting/uniform",
    appraisalSettings: "#/setting/appraisals",
    surveySettings: "#/setting/surveys",
    addUser: "#/setting/adduser",
    userRole: "#/setting/userRole",
    userAccess: "#/setting/useraccess",
    userDetail: "#/setting/adduser/",
    employeeEditForm: "#/setting/employee/editform",
    editskill: "#/setting/employee/editskill",
    forms: "#/setting/forms",
    branchEditForm: "#/setting/branch/editform",

    // Finance module
    paylevel: "#/setting/finance/paylevel",
    paybillcol: "#/setting/finance/paybillcol",
    shifttype: "#/setting/finance/shifttype",
    paytable: "#/setting/finance/paytable",
    premium: "#/setting/finance/premium",
    calculatepaybill: "#/setting/finance/calculatepaybill",


    // module objects
    module:"#/setting/module/config",

    // billing
    service:"#/setting/billing/service",
    payment:"#/setting/billing/payment",
    billingNotification:"#/setting/billing/billingNotification",
    invoiceList:"#/setting/billing/invoices",
    invoiceView:"#/user/invoiceview/",

    // Field Flows (conditional field logic builder)
    fieldFlows: "#/setting/fieldflows",

    // employees sent by WFC Verify, waiting to be approved (importing from a file is on the Employees page)
    pendingEmployees: "#/setting/pendingemployees",

    // Form Management
    reportTemplates:"#/setting/reportmanagement/reporttemplate",
    systemReport:"#/setting/reportmanagement/sysreport",
    reportField:"#/setting/reportmanagement/reportfield",
    scheduleEvent:"#/setting/reportmanagement/scheduleevent",
    scheduleChecks:"#/setting/reportmanagement/schedulechecks",
}

export const publicRoutes = ["/", "/pwd/*", "/classic/*", "/sso"];